import { FC } from 'react';
import _ from 'lodash';
import { useTemplatesContext } from '@components/Contexts/TemplatesContext';
import TemplateCard from '../TemplateCard';
import { TemplateGalleryCard } from '@common/types';
import TemplateCardMobile from '../TemplateCard/TemplateCardMobile/TemplateCardMobile';

type Props = {
  templates?: TemplateGalleryCard[];
  isMobileView: boolean;
};
const TemplateCardListItems: FC<Props> = ({ templates, isMobileView }) => {
  const {
    state: { SSRFlow },
  } = useTemplatesContext();

  return (
    <>
      {_.size(templates) > 0
        ? _.map(templates, (template, index) => (
            <li key={template.id}>
              {isMobileView ? (
                <TemplateCardMobile template={template} forceRender={SSRFlow} />
              ) : (
                <TemplateCard
                  template={template}
                  forceRender={SSRFlow}
                  index={index}
                />
              )}
            </li>
          ))
        : _.map(_.range(0, 4), (index) => (
            <li key={index}>
              {isMobileView ? (
                <TemplateCardMobile
                  template={{ purchaseCount: 0 }}
                  forceRender={false}
                  loader={true}
                />
              ) : (
                <TemplateCard
                  template={{ purchaseCount: 0 }}
                  forceRender={false}
                  loader={true}
                  index={index}
                />
              )}
            </li>
          ))}
    </>
  );
};

export default TemplateCardListItems;
